import { render, staticRenderFns } from "./AdministrationSelectionDialog.vue?vue&type=template&id=dcb54280&"
import script from "./AdministrationSelectionDialog.vue?vue&type=script&lang=ts&"
export * from "./AdministrationSelectionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AdministrationSelectionDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow,VSelect})
